export const HOME_ROUTE = '/';
export const LOGIN_ROUTE = '/login/';
export const ADMINS_ROUTE = '/admins/';
export const ADMINS_CREATE_ROUTE = `${ADMINS_ROUTE}create/`;
export const ADMINS_EDIT_ROUTE = `${ADMINS_ROUTE}:id/edit/`;
export const USERS_ROUTE = '/users/';
export const USERS_USER_ROUTE = `${USERS_ROUTE}:id/`;
export const FAQS_ROUTE = `/faqs/`;
export const FAQS_CREATE_ROUTE = `${FAQS_ROUTE}create/`;
export const FAQS_EDIT_ROUTE = `${FAQS_ROUTE}:id/edit/`;
export const FAQS_LANGUAGE_EDIT_ROUTE = `${FAQS_EDIT_ROUTE}:language/`;
export const LESSONS_ROUTE = `/lessons/`;
export const LESSONS_CREATE_ROUTE = `${LESSONS_ROUTE}create/`;
export const LESSONS_EDIT_ROUTE = `${LESSONS_ROUTE}:id/edit/`;
export const LESSONS_LANGUAGE_EDIT_ROUTE = `${LESSONS_EDIT_ROUTE}:language/`;
export const WELCOME_MESSAGES_ROUTE = '/welcome-messages/';
export const WELCOME_MESSAGES_CREATE_ROUTE = `${WELCOME_MESSAGES_ROUTE}create/`;
export const WELCOME_MESSAGES_EDIT_ROUTE = `${WELCOME_MESSAGES_ROUTE}:id/edit/`;
export const CHATS_ROUTE = '/chats/';
export const CHATS_NEW_ROUTE = `${CHATS_ROUTE}new/`;
export const CHATS_SEARCH_ROUTE = `${CHATS_ROUTE}search/`;
export const CHATS_CHAT_ROUTE = `${CHATS_ROUTE}:id/`;
export const AI_CONTEXT_ROUTE = '/ai-context/';
export const AI_CONTEXT_BOB_CHATS_ROUTE = `${AI_CONTEXT_ROUTE}bob-chats/`;
export const AI_CONTEXT_BOB_CHATS_EXPORT_ROUTE = `${AI_CONTEXT_ROUTE}bob-chats/export.json`;
export const GRAPHQL_ROUTE = '/graphql/';

type ParseUrlParams<url> = url extends `${infer path}(${infer optionalPath})`
  ? ParseUrlParams<path> & Partial<ParseUrlParams<optionalPath>>
  : url extends `${infer start}/${infer rest}` // Slashes
    ? ParseUrlParams<start> & ParseUrlParams<rest>
    : url extends `${infer start}.${infer rest}` // Dots
      ? ParseUrlParams<start> & ParseUrlParams<rest>
      : url extends `:${infer param}`
        ? { readonly [k in param]: string }
        : unknown;

function invariant(cond: any, message: string): asserts cond {
  if (!cond) throw new Error(message);
}

function generatePath<TPath extends string = string>(path: TPath, params: ParseUrlParams<TPath>): string {
  return path
    .replace(/:(\w+)/g, (_, key) => {
      invariant((params as any)[key] != null, `Missing ":${key}" param`);
      return (params as any)[key]!;
    })
    .replace(/\/*\*$/, () => ((params as any)['*'] == null ? '' : (params as any)['*'].replace(/^\/*/, '/')));
}

export function url<TPath extends string = string>(
  path: TPath,
  params: ParseUrlParams<TPath>,
  query?: Record<string, string> | string,
): string {
  let compiled = generatePath(path, params);

  if (query) {
    const qs = new URLSearchParams(query).toString();
    compiled = `${compiled}?${qs}`;
  }

  return compiled;
}
